export default "__VITE_ASSET__f1f08ce1__"